import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "features/config/store";

interface InitialState {
  status: boolean;
}

const initialState: InitialState = {
  status: true,
};

export const ms6SideBarSlice = createSlice({
  name: "ms6SideBar",
  initialState,
  reducers: {
    openMs6SideBar: (state) => {
      state.status = true;
    },
    closeMs6SideBar: (state) => {
      state.status = false;
    },
    toggleMs6SideBar: (state) => {
      state.status = !state.status;
    },
  },
});

export const selectMs6SideBar = (state: RootState) => state.ms6SideBar;

export const { openMs6SideBar, closeMs6SideBar, toggleMs6SideBar } =
  ms6SideBarSlice.actions;

export default ms6SideBarSlice.reducer;
